import { useEffect, useState } from "react";
import { useMutation } from "react-query";
import axios from "axios";
import Config from "../../Config";
import { useSelector } from "react-redux";
import tw from "tailwind-styled-components";
import { toast } from "react-toastify";
import {
    BoxContainer,
    BoxHead,
    Underline,
    BoxTitle,
} from "../../Components/Styles/PageStyles";
import SideModal from "../../Components/SideModal";
import NotFoundModel from "../../Components/NotFoundModel";
import {
    MdAdd,
    MdChevronRight,
} from "react-icons/md";
import CreateFolder from "../../Components/OwnerDocuments/CreateFolder";
import OwnerDocumentUploadModal from "../../Components/OwnerDocuments/OwnerDocumentUploadModal";
import Loading from "../../Components/Loading";
import DocumentCards from "../../Components/OwnerDocuments/DocumentCard";
//import { AddBtn } from "../../Components/Styles/InputStyles";
import DocumentActionMenu from "../../Components/OwnerDocuments/DocumentActionMenu";

const OwnerDocuments = () => {
    const user = useSelector((state) => state.UserReducer.user);
    const [currentPath, setCurrentPath] = useState([]);
    const [currentItems, setCurrentItems] = useState([]);
    const [isUploadModalOpen, setIsUploadModalOpen] = useState(false);
    const [isCreateFolderModalOpen, setIsCreateFolderModalOpen] = useState(false);
    const [apiData, setApiData] = useState();
    const [isActionOpen, setIsActionOpen] = useState(false);
    const [deletingId, setDeletingId] = useState(null);

    useEffect(() => {
        const handler = setTimeout(() => {
            getListMutate();
        }, 100);

        return () => clearTimeout(handler);
    }, []);

    const fetchFunction = async (folderId) => {
        const response = await axios.get(
            `${Config.apiUrl}/official-documents/list`,
            {
                params: {
                    folderIdQuery: folderId,
                },
                headers: {
                    authorization: `Bearer ${user.token}`,
                    "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8",
                },
            },
        );

        return response.data;
    };

    const getSuccess = (res) => {
        if (!res.isSuccess) {
            toast.error(res.msg);
            return;
        }

        setApiData(res.data);
        setCurrentItems(res.data);
    };

    const getError = (res) => { };

    const {
        isLoading: getListLoading,
        mutate: getListMutate,
        error,
        data,
        isRefetching,
    } = useMutation(fetchFunction, {
        onSuccess: getSuccess,
        onError: getError,
    });

    //------- Upload Document --------------------------
    const uploadDocumentFunction = async (values) => {
        return await axios.post(
            `${Config.apiUrl}/official-documents/upload/document`,
            values,
            {
                headers: {
                    authorization: `Bearer ${user.token}`,
                    "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8",
                },
            },
        );
    };

    const onUploadDocSuccess = (data) => {
        setIsUploadModalOpen(false);

        if (!data?.data?.isSuccess) {
            toast.error(data?.data?.msg || "An Error Occured");
            return;
        }

        if (currentPath.length === 0) {
            // Root
            getListMutate();
        } else {
            // Current opened folder
            const folderId = currentPath[currentPath.length - 1].id;
            getListMutate(folderId);
        }

        toast.success(data.data.msg);
    };

    const onUploadDocError = (data) => {
        setIsUploadModalOpen(false);
        toast.error(data?.response?.data?.msg || "An Error Occured");
    };

    const { isLoading: isDocLoading, mutate: uploadDocMutate } = useMutation(
        uploadDocumentFunction,
        {
            onSuccess: onUploadDocSuccess,
            onError: onUploadDocError,
        },
    );

    //------- Create Folder ------------------------
    const createFolderFunction = async (body) => {
        return await axios.post(
            `${Config.apiUrl}/official-documents/createfolder`,
            body,
            {
                headers: {
                    authorization: `Bearer ${user.token}`,
                    "Content-Type": "application/json",
                },
            },
        );
    };

    const onCreateFolderSuccess = (data) => {
        if (!data?.data?.isSuccess) {
            toast.error(data?.data?.msg || "An Error Occured");
            return;
        }
        setIsCreateFolderModalOpen(false);
        if (currentPath.length === 0) {
            getListMutate();
        } else {
            const folderId = currentPath[currentPath.length - 1].id;
            getListMutate(folderId);
        }

        toast.success(data.data.msg);
    };

    const onCreateFolderError = (data) => {
        setIsCreateFolderModalOpen(false);
        toast.error(data?.response?.data?.msg || "An Error Occured");
    };

    const { isLoading: isCreateLoading, mutate: createFolderMutate } =
        useMutation(createFolderFunction, {
            onSuccess: onCreateFolderSuccess,
            onError: onCreateFolderError,
        });

    const handleActionToggle = () => {
        setIsActionOpen((prev) => !prev);
    };

    const handleUploadClick = () => {
        setIsUploadModalOpen(true);
        setIsActionOpen(false);
    };

    const handleCreateFolderClick = () => {
        setIsCreateFolderModalOpen(true);
        setIsActionOpen(false);
    };

    const handleCloseUploadModal = () => {
        setIsUploadModalOpen(false);
    };

    const handleCloseCreateFolderModal = () => {
        setIsCreateFolderModalOpen(false);
    };

    // Navigate into a folder
    const handleFolderClick = (folder) => {
        getListMutate(folder.id);
        setCurrentPath([...currentPath, { id: folder.id, title: folder.name }]);
    };

    const handleBackClick = () => {
        const newPath = [...currentPath];
        newPath.pop();

        setCurrentPath(newPath);

        if (newPath.length === 0) {
            // Back to root folders
            getListMutate();
        } else {
            // Load previous folder
            const previousFolderId = newPath[newPath.length - 1].id;
            getListMutate(previousFolderId); // or getFolderMutate(previousFolderId)
        }
    };

    const formatDate = (date) => {
        if (!date) return "";
        try {
            return new Date(date).toLocaleDateString("en-US", {
                month: "long",
                day: "numeric",
                year: "numeric",
            });
        } catch {
            return "";
        }
    };

    // Render breadcrumb navigation
    // const renderBreadcrumb = () => {
    //     return (
    //         <div className="flex items-center gap-2 flex-wrap">
    //             {currentPath.length > 0 && (
    //                 <button
    //                     onClick={handleBackClick}
    //                     className="flex items-center gap-1 text-primary-color hover:underline text-sm"
    //                 >
    //                     <MdArrowBack size={16} />
    //                     Back
    //                 </button>
    //             )}
    //             <div className="flex items-center gap-1 text-sm text-gray-600">
    //                 <span className="font-medium">Root</span>
    //                 {currentPath.map((folder, index) => (
    //                     <span key={index} className="flex items-center gap-1">
    //                         <span className="text-gray-400">/</span>
    //                         <span className="font-medium">{folder.title}</span>
    //                     </span>
    //                 ))}
    //             </div>
    //         </div>
    //     );
    // };
    const handleBreadcrumbClick = (index) => {
        if (index === -1) {
            setCurrentPath([]);
            getListMutate();
            return;
        }

        const newPath = currentPath.slice(0, index + 1);
        setCurrentPath(newPath);
        getListMutate(newPath[newPath.length - 1].id);
    };

    const renderBreadcrumb = () => (
        <div className="mt-4 mb-2 flex items-center gap-4">

            <div className="flex items-center flex-wrap text-sm">
                <button
                    onClick={() => handleBreadcrumbClick(-1)}
                    className={`flex items-center gap-1 text-sm transition ${currentPath.length === 0
                        ? "font-semibold text-primary-color"
                        : "text-gray-600 hover:text-primary-color"
                        }`}
                >
                    Documents
                </button>

                {currentPath.map((folder, index) => (
                    <>
                        <MdChevronRight
                            size={18}
                            className="mx-1 text-gray-400"
                        />

                        <button
                            onClick={() => handleBreadcrumbClick(index)}
                            className={
                                index === currentPath.length - 1
                                    ? "font-semibold text-primary-color"
                                    : "font-medium text-gray-600 hover:text-primary-color"
                            }
                        >
                            {folder.title}
                        </button>
                    </>
                ))}
            </div>

            {/* {currentPath.length > 0 && (
                <button
                    onClick={handleBackClick}
                    className="flex items-center gap-1 rounded-md border border-gray-200 px-3 py-2 text-sm text-gray-600 hover:bg-gray-100"
                >
                    <MdArrowBack size={18} />
                    Back
                </button>
            )} */}
        </div>
    );

    const { isLoading: isDeleteLoading, mutate: deleteMutate } = useMutation(
        (body) =>
            axios.post(
                `${Config.apiUrl}/official-documents/delete`,
                body,
                {
                    headers: {
                        authorization: `Bearer ${user.token}`,
                        "Content-Type": "application/json",
                    },
                }
            ),
        {
            onSuccess: (data) => {
                if (!data?.data?.isSuccess) {
                    toast.error(data?.data?.msg || "An Error Occurred");
                    return;
                }

                if (currentPath.length === 0) {
                    getListMutate();
                } else {
                    getListMutate(currentPath[currentPath.length - 1].id);
                }

                toast.success(data.data.msg);
            },
            onError: (error) => {
                toast.error(error?.response?.data?.msg || "An Error Occurred");
            },
        }
    );

    const handleDelete = (item) => {
        setDeletingId(item.id);

        deleteMutate(
            { id: item.id, type: item.type === 'folder' ? 1 : 2 },
            {
                onSettled: () => setDeletingId(null),
            }
        );
    };

    return (
        <BoxContainer className="!h-auto">
            <BoxHead>
                <BoxTitle className="!mb-0 whitespace-nowrap">
                    Documents
                    <Underline />
                </BoxTitle>
                <div className="relative ml-auto">
                    <DocumentActionMenu
                        isOpen={isActionOpen}
                        onUploadClick={handleUploadClick}
                        onCreateFolderClick={handleCreateFolderClick}
                    />

                    <AddBtn onClick={handleActionToggle}>
                        <MdAdd
                            size={18}
                            className={`mr-1 transition-transform ${isActionOpen ? "rotate-45" : ""
                                }`}
                        />
                        New
                    </AddBtn>
                </div>
            </BoxHead>

            {renderBreadcrumb()}
            {!error && !getListLoading && data && (
                <>
                    {!currentItems || currentItems.length === 0 ? (
                        <NotFoundModel msg={"No documents or folders found"} />
                    ) : (
                        <DocumentCards
                            currentItems={currentItems}
                            handleFolderClick={handleFolderClick}
                            formatDate={formatDate}
                            handleDelete={handleDelete}
                            isDeleteLoading={isDeleteLoading}
                            deletingId={deletingId}
                        />
                    )}
                </>
            )}
            {error && !getListLoading && (
                <NotFoundModel msg="No documents or folders found" />
            )}

            {(getListLoading || isRefetching) && <Loading />}

            <SideModal
                isOpen={isUploadModalOpen}
                onClose={handleCloseUploadModal}
            >
                <OwnerDocumentUploadModal
                    handleClose={handleCloseUploadModal}
                    uploadDocMutate={uploadDocMutate}
                    isDocLoading={isDocLoading}
                    currentPath={currentPath}
                    folders={apiData || []}
                />
            </SideModal>

            <SideModal
                isOpen={isCreateFolderModalOpen}
                onClose={handleCloseCreateFolderModal}
            >
                <CreateFolder
                    handleClose={handleCloseCreateFolderModal}
                    createFolderMutate={createFolderMutate}
                    isCreateLoading={isCreateLoading}
                    currentPath={currentPath}
                />
            </SideModal>
        </BoxContainer>
    );
};

const AddBtn = tw.button`${(p) =>
    p.$active
        ? "bg-gray-100"
        : ""} border whitespace-nowrap border-gray-200 flex space-x-1.5 justify-center items-center text-white h-full rounded-md px-6 cursor-pointer bg-gradient-to-r from-primary-color to-[#00A0FF] hover:brightness-110 py-2.5 text-sm`;

export default OwnerDocuments;
